var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.items && _vm.items.length > 0,
          expression: "items && items.length > 0"
        }
      ],
      staticClass: "selected-list"
    },
    _vm._l(_vm.items, function(item) {
      return _c("li", { staticClass: "selected-list__item" }, [
        _c("span", { staticClass: "selected-list__item-inner" }, [
          _vm._v("\n      " + _vm._s(item.label) + "\n      "),
          _c("button", {
            staticClass: "button button--close",
            attrs: { "aria-label": "Slett" },
            on: {
              click: function($event) {
                return _vm.deleteItem(item.id)
              }
            }
          })
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }